import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea, Checkbox } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { AttachmentIcon } from "services/Recruit/assets/svg/AttachmentIcon";
import { Field, Formik, Form } from "formik";
import CustomDatePicker from "common/components/datePicker/CustomDatePicker";
import { useEffect, useState } from "react";
import TextEditor from "common/components/textEditor/TextEditor";
import { useNavigate, useParams } from "react-router-dom";
import { constant } from "common/constant";
import { interviewTabsData } from "services/Recruit/data/tabsData";
import { dropdownOptions } from "services/Recruit/data/dropdownData";
import FileUpload from "common/components/fileUpload/FileUpload";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { jobProfileSchema } from "services/Recruit/schema/jobProfileSchema";
import { addRecruitmentProfile } from "common/redux/reducers/recruitmentSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { CREATE_JOB_OPENING_INITIAL_VALUES } from "common/initialValues/formInitialValues";
import { toast } from "react-toastify";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { putApi } from "common/services/api";
import { InterviewData } from "services/Recruit/data/interviewData";
import { interviewSchema } from "services/Recruit/schema/interviewSchema";
import { interviewerOptions } from "services/Recruit/data/dropdownData";
import { interviewRoundOptions } from "services/Recruit/data/dropdownData";
import { interviewTypeOptions } from "services/Recruit/data/dropdownData";
import { candidateOptions } from "services/Recruit/data/dropdownData";
import { reminderOptions } from "services/Recruit/data/dropdownData";


const CreateInterview = () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { id } = useParams();
    const [jobData, setJobData] = useState(null);
    const [showCommentCandidate, setShowCommentCandidate] = useState(false);
    const [showReminder, setShowReminder] = useState(false);
    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    const handleNext = () => {
        if (activeTabIndex < 3) {
            setActiveTabIndex(activeTabIndex + 1);
        }
    };

    const handleBack = () => {
        if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
        }
    }

    const handleFileChange = (dispatch, setFieldValue, fieldName) => async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const result = await dispatch(uploadAttachment({ file, setFieldValue, fieldName }));
                const attachmentId = result.payload;
                if (attachmentId) {
                    setFieldValue(fieldName, attachmentId);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    // useEffect(() => {
    //     if (id) {
    //         const fetchTaskData = async () => {
    //             try {
    //                 let result = await getApi(API_PATHS.RECRUITMENT_PROFILES, id);
    //                 setJobData(result?.data);
    //             } catch (e) {
    //                 toast.error(constant.somethingWrong);
    //             }
    //         };

    //         fetchTaskData()
    //     }
    // }, [id])

    const EditData = async (values) => {
        try {
            let response = await putApi(
                `${API_PATHS.POST_RECRUITMENT_PROFILES}/${id}`,
                values
            );
            if (response.status === 200) {
                navigate("/recruit/Interview");
            }
        } catch (e) {
            toast.error(constant.somethingWrong);
        } finally {
        }
    };

    return (
        <>
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/Interview")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{id ? constant.editInterview : constant.createInterview}</Text>
                        </Box>
                    </Box>

                    <Formik
                        enableReinitialize
                        initialValues={
                            InterviewData
                                ? {
                                    ...InterviewData,
                                    department: InterviewData.id || "",
                                }
                                : CREATE_JOB_OPENING_INITIAL_VALUES
                        }
                        validationSchema={interviewSchema}
                        onSubmit={(values, { resetForm }) => {
                            if (id) {
                                // EditData(values);
                                navigate("/recruit/Interview");
                            } else {
                                // dispatch(addRecruitmentProfile({ values, resetForm, navigate }));
                                navigate("/recruit/Interview");
                            }
                        }}
                    >
                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {interviewTabsData.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="jobTitle">{constant.jobTitle}</FormLabel>
                                                        <Field name="jobTitle">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select value={field.value || ""} {...field} defaultValue="">
                                                                        <option selected hidden value="">{constant.jobTitle}</option>
                                                                        {dropdownOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <div>{meta.error}</div>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="candidate">{constant.candidate}</FormLabel>
                                                        <Field name="candidate">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        value={field.value || ""}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectCandidate}</option>
                                                                        {candidateOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="candidateEmail">
                                                            {constant.candidateEmail}
                                                        </FormLabel>
                                                        <Field name="candidateEmail">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={constant.candidateEmail}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="candidatePhoneNo">{constant.candidatePhoneNo}</FormLabel>
                                                        <Field name="candidatePhoneNo">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="number"
                                                                        placeholder={constant.candidatePhoneNo}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <div>{meta.error}</div>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="interviewer">{constant.interviewer}</FormLabel>
                                                        <Field name="interviewer">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectInterviewer}</option>
                                                                        {interviewerOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="round">{constant.round}</FormLabel>
                                                        <Field name="round">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectRound}</option>
                                                                        {interviewRoundOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="interviewType">{constant.interviewType}</FormLabel>
                                                        <Field name="interviewType">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        value={field.value || ""}
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{constant.selectInterviewType}</option>
                                                                        {interviewTypeOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                            <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                {constant[label] || label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="targetDate">{constant.targetDate}</FormLabel>
                                                        <Field name="targetDate">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <CustomDatePicker
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="startOn">{constant.startOn}</FormLabel>
                                                        <Field name="startOn">
                                                            {({ field, meta, form }) => (
                                                                <>
                                                                     <CustomDatePicker
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="startTime">{constant.startTime}</FormLabel>
                                                        <Field name="startTime">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <CustomDatePicker
                                                                        time={true}
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                            <Box className="createJobOpening-tabsPanelFooter">
                                                   <Button  className="backBtn" onClick={()=>navigate("/recruit/Interview")}>{constant.back}</Button>
                                                <Button className="nextBtn" variant="primary" onClick={handleNext}>{constant.next}</Button>
                                            </Box>
                                        </TabPanel>

                                        {/* Description information */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Box w={'100%'}>
                                                    <Text className="textEditorHeading">{constant.commentForInterviewer}</Text>
                                                    <Field name="commentForInterviewer">
                                                        {({ field, meta }) => (
                                                            <>
                                                                <Textarea
                                                                    className="coverLetter"
                                                                    placeholder={constant.CoverLetter}
                                                                    size="md"
                                                                    resize="none"
                                                                    w="100%"
                                                                />
                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                            </>
                                                        )}
                                                    </Field>
                                                </Box>

                                                <Box w={'100%'}>
                                                    <Box>
                                                        <Checkbox  onChange={() => setShowCommentCandidate(prev => !prev)} sx={{ fontSize: "sm" }}>
                                                            <Text fontSize="14px">
                                                                {constant.notifyCandidate}
                                                            </Text>
                                                        </Checkbox>
                                                    </Box>
                                                    {showCommentCandidate &&
                                                        <>
                                                            <Text  sx={{ marginTop: "20px" }} className="textEditorHeading">{constant.commentForCandidate}</Text>
                                                            <Field name="commentForCandidate">
                                                                {({ field, meta }) => (
                                                                    <>
                                                                        <Textarea
                                                                            className="coverLetter"
                                                                            placeholder={constant.CoverLetter}
                                                                            size="md"
                                                                            resize="none"
                                                                            w="100%"
                                                                        />
                                                                        {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                    </>
                                                                )}
                                                            </Field>
                                                        </>
                                                    }
                                                    
                                                </Box>

                                                <Box width={'100%'}>
                                                    <Box sx={{ marginBottom: "20px" }}>
                                                        <Checkbox onChange={() => setShowReminder(prev => !prev)}>
                                                            <Text fontSize="14px">
                                                                {constant.setReminder}
                                                            </Text>
                                                        </Checkbox>
                                                    </Box>
                                                    {showReminder
                                                        &&
                                                        <>
                                                            <Flex sx={{ marginTop: "20px" }} gap={'20px'}>
                                                                <Box w={'50%'}>
                                                                    <FormLabel htmlFor="remindBefore">{constant.remindBefore}</FormLabel>
                                                                    <Field name="remindBefore">
                                                                        {({ field, meta }) => (
                                                                            <>
                                                                                <Input
                                                                                    {...field}
                                                                                    type="number"
                                                                                    placeholder={constant.remindBeforePlaceholder}
                                                                                    borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                                />
                                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                </Box>

                                                                <Box w={'50%'}>
                                                                    <FormLabel htmlFor="reminderOption">{constant.reminderOption}</FormLabel>
                                                                    <Field name="reminderOption">
                                                                        {({ field, meta }) => (
                                                                            <>
                                                                                <Select
                                                                                    {...field}
                                                                                    value={field.value || ""}
                                                                                    defaultValue=""
                                                                                    borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                                >
                                                                                    <option selected hidden value="">{constant.reminderOptionSelect}</option>
                                                                                    {reminderOptions.map(({ value, label, disabled, hidden }, index) => (
                                                                                        <option key={index} value={value} disabled={disabled} hidden={hidden}>
                                                                                            {constant[label] || label}
                                                                                        </option>
                                                                                    ))}
                                                                                </Select>
                                                                                {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                            </>
                                                                        )}
                                                                    </Field>
                                                                </Box>
                                                            </Flex>
                                                        </>
                                                    }

                                                </Box>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button onClick={handleBack} className="backBtn">{constant.back}</Button>
                                                <Button
                                                    // disabled={!isValid || (!id && !dirty)}
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                >
                                                    {id ? constant.update : constant.save}
                                                </Button>
                                            </Box>

                                        </TabPanel>
                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </>
    );
};

export default CreateInterview;
